/* global Plyr, Swiper */

'use strict';

const $ = window.jQuery;

module.exports = function () {
    if ($('body').hasClass('home')) {
        // Finder
        $('#homepageFinder').submit(function (e) {
            const priceMin = parseFloat($('#price-range').val().split(',')[0])
            const priceMax = parseFloat($('#price-range').val().split(',')[1])
            const school = $('#schools').val()
            const cities = $('#cities').val()
            let url = $(this).attr('action')

            e.preventDefault()

            if ($('.tab-cities').hasClass('active')) {
                url = `${url}?${cities.length ? `&related_city=${cities}` : ''}${priceMin !== 0 ? `&price_from=${priceMin}` : ''}${priceMax < 1000 ? `&price_to=${priceMax}` : ''}`
            } else {
                url = `${url}?${school !== 'null' ? `&related_school=${school}` : '' }${priceMin !== 0 ? `&price_from=${priceMin}` : ''}${priceMax < 1000 ? `&price_to=${priceMax}` : ''}`
            }

            window.location.href = url;
        });

        // Residence form
        $('.range-slider').jRange({
            from: 0,
            to: 1000,
            step: 50,
            width: 400,
            showLabels: true,
            format: '%s€',
            showScale: false,
            isRange: true
        });

        // News
        const homeNews = new Swiper('#newsList', {
            slidesPerView: '1',
            // effect: 'fade',
            loop: true,
            grabCursor: true,
            navigation: {
                nextEl: '#newsNext',
                prevEl: '#newsPrev'
            }
        });

        // Residences
        const homeResidences = new Swiper('#residencesList', {
            slidesPerView: '1',
            grabCursor: true,
            spaceBetween: 60,
            scrollbar: {
                el: '.swiper-scrollbar',
                hide: false,
                draggable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: '2'
                },
                1024: {
                    slidesPerView: '3'
                }
            }
        });

        gsap.timeline({
            scrollTrigger: {
                trigger: '#residencesList',
                start: 'top 80%'
            }
        }).staggerFrom('.card-residence', .5, {
            opacity: 0,
            x: 50,
            stagger: 0.2,
        });

        // Steps
        gsap.timeline({
            scrollTrigger: {
                trigger: '.steps',
                start: 'top 80%'
            }
        }).staggerFrom('.steps__item', .5, {
            opacity: 0,
            x: 50,
            stagger: 0.2,
        });

        // Services
        const homeServices = new Swiper('#servicesList', {
            direction: 'vertical',
            slidesPerView: '5',
            parallax: true,
            speed: 1000,
            centeredSlides: true,
            grabCursor: true,
            autoplay: {
                delay: 500
            },
            mousewheel: {
                sensitivity: 100
            },
            loop: true,
            spaceBetween: 20,
            breakpoints: {
                768: {
                    slidesPerView: 'auto'
                }
            }
        });

        // Video
        gsap.from('.home-video__video', {
            scrollTrigger: {
                trigger: '.home-video__video',
                start: 'top 80%'
            },
            opacity: 0,
            y: 50,
            duration: .5,
        });

        // FAQ
        gsap.timeline({
            scrollTrigger: {
                trigger: '.home-faq__list',
                start: 'top 80%'
            }
        }).staggerFrom('.home-faq__list__item', .5, {
            opacity: 0,
            x: 50,
            stagger: 0.2,
        });
    }
};
